<template>
  <section class="c-section c-section--servicios">
    <MainBanner
      slider="false"
      bg1="6"
      bg2=""
      bg3=""
      title1="Esport as a profitable"
      title2="investment for brands"
      showText="true"
      :textBanner="banner.text"
      showBtn="false"
      btnUrl=""
    ></MainBanner>

    <div class="c-tab-serv">
      <div class="c-tab-serv__scroll">
        <ul class="c-tab-serv__head d-flex align-items-center">
          <li></li>
          <li>
            <button @click="step=1" class="c-button c-button--primary-solo"
              :class="{'active' : step == 1 }">
              <span>
                Own Products <Icon icon="icon-park-outline:double-right" />
              </span>
            </button>
          </li>
          <li>
            <button @click="step=2"  class="c-button c-button--primary-solo"
            :class="{'active' : step == 2 }">
              <span>
                Broadcast ES Rights <Icon icon="icon-park-outline:double-right" />
              </span>
            </button>
          </li>
          <li>
            <button @click="step=3" class="c-button c-button--primary-solo"
            :class="{'active' : step == 3 }">
              <span>
                Esports Production <Icon icon="icon-park-outline:double-right" />
              </span>
            </button>
          </li>
          <li></li>
        </ul>
      </div>
      <div class="c-tab-serv__body">
        <transition duration="300" name="fade" mode="out-in">
          <div v-if="step === 1" key="home">
            <div>
              <div class="container">
                <div class="mb-4">
                  <h4><strong>Elite League:</strong></h4>
                  <p>
                    “Elite League seeks to be the world's leading
                    multi-discipline competitive tournament that
                    brings together the best players and tells the
                    most compelling stories.”
                  </p>

                  <h4><strong>Open League:</strong></h4>
                  <p>
                    “Open League aims to be the biggest gathering in
                    the esports world, an iconic event that happens every
                    year in Qatar, where all gamers can live the dream
                    of being pro-players.”
                  </p>
                </div>

                <div class="c-mazonri c-mazonri--tiktok">
                  <div class="c-mazonri__container">
                    <div class="c-mazonri__item"
                      @click="openImgModal('servicios/own/gallery/1.jpg')">
                      <a>
                        <img src="@/assets/images/servicios/own/gallery/1.jpg">
                      </a>
                    </div>
                    <div class="c-mazonri__item"
                      @click="openImgModal('servicios/own/gallery/2.jpg')">
                      <a>
                        <img src="@/assets/images/servicios/own/gallery/2.jpg">
                      </a>
                    </div>
                    <div class="c-mazonri__item"
                      @click="openImgModal('servicios/own/gallery/3.jpg')">
                      <a>
                        <img src="@/assets/images/servicios/own/gallery/3.jpg">
                      </a>
                    </div>
                    <!-- <div class="c-mazonri__item"
                      @click="openImgModal('1.jpg')">
                      <a>
                        <img src="@/assets/images/bg-2.jpg">
                      </a>
                    </div>
                    <div class="c-mazonri__item"
                      @click="openImgModal('1.jpg')">
                      <a>
                        <img src="@/assets/images/bg-2.jpg">
                      </a>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="step === 2" key="dos">
            <div>
              <div class="container">
                <div class="mb-5">
                  <h4><strong>BetBoom Dacha:</strong></h4>
                  <p>
                    Last year we broadcasted in English the first
                    BetBoom Dacha, a $250,000 Dota 2 tournament created
                    by the Russian bookmaker where the best teams in the
                    world participate. This 2024, we are pleased to
                    announce that we will be broadcasting the new
                    BetBoom Dacha Dubai 2024.
                  </p>

                  <h4><strong>ESL Pro Tour: </strong></h4>
                  <p>
                    We are pleased to share that we have signed a
                    partnership with ESL Pro Tour to be their official
                    Spanish language broadcasters in the Dota 2 circuit,
                    where we will be covering different tournaments well
                    known by the community such as ESL One, Dreamleagues
                    and more.
                  </p>

                  <h4><strong>PGL:</strong></h4>
                  <p>
                    With PGL we have signed a partnership to
                    broadcast their 2 Counter Strike 2 majors
                    this year, which will be held in Copenhagen
                    and Shanghai. With this production we hope to
                    expand our market to Spanish speaking audiences
                    in Spain and Argentina.
                  </p>
                </div>
              </div>
              <div v-if="false" class="">
                <div class="c-areas">
                  <div class="container">
                    <div class="c-tab-serv__scroll">
                      <ul class="c-tab-serv__head d-flex align-items-center">
                        <li class="d-none d-lg-block"></li>
                        <li>
                          <button @click="area=1" :class="{'active' : area == 1 }">
                            Audiovisuales
                          </button>
                        </li>
                        <li>
                          <button @click="area=2" :class="{'active' : area == 2 }">
                            Creatividad
                          </button>
                        </li>
                        <li>
                          <button @click="area=3" :class="{'active' : area == 3 }">
                            Social Media
                          </button>
                        </li>

                        <li>
                          <button @click="area=4" :class="{'active' : area == 4 }">
                            Planeamiento Estratégico
                          </button>
                        </li>
                        <li></li>
                      </ul>
                    </div>
                  </div>

                  <div class="c-areas__body">
                    <transition duration="300" name="fade" mode="out-in">
                      <div v-if="area === 1" key="1">
                        <div class="c-slide position-relative">
                          <div class="c-bottom-shadow position-absolute w-100 h-100">
                          </div>
                          <div class="c-shadow position-absolute w-100 h-100">
                          </div>
                          <div class="c-bar c-bar--bottom w-100 position-absolute d-flex
                            justify-content-between align-items-center">
                            <!-- <img src="@/assets/img/diagonal-bars.png"> -->
                            <div class="c-line"></div>
                          </div>
                          <div class="swiper-container">
                            <div class="swiper-wrapper">
                              <div class="swiper-slide">
                                <div class="c-board"
                                  @click="openImgModal('1.jpg')">
                                  <img class="w-100" src="@/assets/images/boards/1.jpg">
                                </div>
                              </div>
                              <div class="swiper-slide">
                                <div class="c-board"
                                  @click="openImgModal('2.jpg')">
                                  <img class="w-100" src="@/assets/images//boards/2.jpg">
                                </div>
                              </div>
                              <div class="swiper-slide">
                                <div class="c-board"
                                  @click="openImgModal('1.jpg')">
                                  <img class="w-100" src="@/assets/images/boards/1.jpg">
                                </div>
                              </div>
                            </div>
                            <div class="swiper-button-next">
                              <Icon icon="akar-icons:chevron-right" />
                            </div>
                            <div class="swiper-button-prev">
                              <Icon icon="akar-icons:chevron-left" />
                            </div>
                          </div>
                          <div class="container position-relative">
                            <div class="row justify-content-center">
                              <div class="col-12 col-md-6 col-lg-6">
                                <div class="c-slide__subtitle">
                                  <p class="black mb-0 text-center">
                                    <strong>// Nuestros mejores proyectos //</strong>
                                  </p>
                                  <div class="c-line">
                                    <span class="l">
                                      <Icon icon="akar-icons:chevron-left" />
                                    </span>
                                    <span class="r">
                                      <Icon icon="akar-icons:chevron-right" />
                                    </span>
                                  </div>
                                  <p class="c-slide__bottomtext black text-center mb-0">
                                    (Click para verlo en fullscreen)
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="area === 2" key="2">
                        <div class="c-slide position-relative">
                          <div class="c-bottom-shadow position-absolute w-100 h-100">
                          </div>
                          <div class="c-shadow position-absolute w-100 h-100">
                          </div>
                          <div class="c-bar c-bar--bottom w-100 position-absolute d-flex
                            justify-content-between align-items-center">
                            <!-- <img src="@/assets/img/diagonal-bars.png"> -->
                            <div class="c-line"></div>
                          </div>
                          <div class="swiper-container">
                            <div class="swiper-wrapper">
                              <div class="swiper-slide">
                                <div class="c-board"
                                  @click="openImgModal('1.jpg')">
                                  <img class="w-100" src="@/assets/images/boards/1.jpg">
                                </div>
                              </div>
                              <div class="swiper-slide">
                                <div class="c-board"
                                  @click="openImgModal('2.jpg')">
                                  <img class="w-100" src="@/assets/images//boards/2.jpg">
                                </div>
                              </div>
                              <div class="swiper-slide">
                                <div class="c-board"
                                  @click="openImgModal('1.jpg')">
                                  <img class="w-100" src="@/assets/images/boards/1.jpg">
                                </div>
                              </div>
                            </div>
                            <div class="swiper-button-next">
                              <Icon icon="akar-icons:chevron-right" />
                            </div>
                            <div class="swiper-button-prev">
                              <Icon icon="akar-icons:chevron-left" />
                            </div>
                          </div>
                          <div class="container position-relative">
                            <div class="row justify-content-center">
                              <div class="col-12 col-md-6 col-lg-6">
                                <div class="c-slide__subtitle">
                                  <p class="black mb-0 text-center">
                                    <strong>// Nuestros mejores proyectos //</strong>
                                  </p>
                                  <div class="c-line">
                                    <span class="l">
                                      <Icon icon="akar-icons:chevron-left" />
                                    </span>
                                    <span class="r">
                                      <Icon icon="akar-icons:chevron-right" />
                                    </span>
                                  </div>
                                  <p class="c-slide__bottomtext black text-center mb-0">
                                    (Click para verlo en fullscreen)
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
              <div class="container">
                <div class="c-mazonri c-mazonri--tiktok">
                  <div class="c-mazonri__container">
                    <div class="c-mazonri__item"
                      @click="openImgModal('servicios/broad/gallery/1.jpg')">
                      <a>
                        <img src="@/assets/images/servicios/broad/gallery/1.jpg">
                      </a>
                    </div>
                    <div class="c-mazonri__item"
                      @click="openImgModal('servicios/broad/gallery/2.jpg')">
                      <a>
                        <img src="@/assets/images/servicios/broad/gallery/2.jpg">
                      </a>
                    </div>
                    <div class="c-mazonri__item"
                      @click="openImgModal('servicios/broad/gallery/3.jpg')">
                      <a>
                        <img src="@/assets/images/servicios/broad/gallery/3.jpg">
                      </a>
                    </div>
                    <!-- <div class="c-mazonri__item"
                      @click="openImgModal('1.jpg')">
                      <a>
                        <img src="@/assets/images/bg-2.jpg">
                      </a>
                    </div>
                    <div class="c-mazonri__item"
                      @click="openImgModal('1.jpg')">
                      <a>
                        <img src="@/assets/images/bg-2.jpg">
                      </a>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="step === 3" key="tres">
            <div>
              <div class="container">
                <div class="mb-4">
                  <h4><strong>Moonton:</strong></h4>
                  <p>
                    For Moonton, publisher of Mobile Legends, we
                    work on four pillars: Soft Landing,
                    Broadcasting, Production and Sponsorships.
                    We were in charge of the official broadcasting
                    for the region of important tournaments within
                    its competitive ecosystem such as M4 and MLSL.
                  </p>

                  <h4><strong>Redbull:</strong></h4>
                  <p>
                    This year we were in charge of the production
                    of the Red Bull Campus Clutch Peru 2023.
                    A world university tournament that brings
                    together the best student players of Valorant.
                    The final of this tournament was held in a
                    movie theater, one of the largest cinema
                    chains in the country, where the audience
                    could see their favorite players live and
                    have the experience of watching the
                    tournament on a giant screen.
                  </p>
                </div>

                <div class="c-mazonri c-mazonri--tiktok">
                  <div class="c-mazonri__container">
                    <div class="c-mazonri__item"
                      @click="openImgModal('servicios/prod/gallery/1.jpg')">
                      <a>
                        <img src="@/assets/images/servicios/prod/gallery/1.jpg">
                      </a>
                    </div>
                    <div class="c-mazonri__item"
                      @click="openImgModal('servicios/prod/gallery/2.jpg')">
                      <a>
                        <img src="@/assets/images/servicios/prod/gallery/2.jpg">
                      </a>
                    </div>
                    <div class="c-mazonri__item"
                      @click="openImgModal('servicios/prod/gallery/3.jpg')">
                      <a>
                        <img src="@/assets/images/servicios/prod/gallery/3.jpg">
                      </a>
                    </div>
                    <!-- <div class="c-mazonri__item"
                      @click="openImgModal('1.jpg')">
                      <a>
                        <img src="@/assets/images/bg-2.jpg">
                      </a>
                    </div>
                    <div class="c-mazonri__item"
                      @click="openImgModal('1.jpg')">
                      <a>
                        <img src="@/assets/images/bg-2.jpg">
                      </a>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <BottomForm></BottomForm>

  <b-modal
    id="modalImg"
    title="BootstrapVue" hide-footer hide-header hide-actions centered size="sm"
    >
    <div class="c-modal">
      <div class="c-board">
        <span @click="$bvModal.hide('modalImg')" class="c-modal__cross fs-30">
          <Icon icon="gridicons:cross-circle" />
        </span>
        <v-zoomer
            style="width: 100vw; height: 100vh;"
            :double-click-to-zoom="false"
            :mouseWheelToZoom="false"
            pivot="image-center"
            :zoomingElastic="false"
            :maxScale="4"
            >
          <img :src="require(`@/assets/images/${popupImgContent}`)" class="w-100 h-100">
        </v-zoomer>
        </div>
    </div>
  </b-modal>
  </section>
</template>

<script>
import VueZoomer from 'vue-zoomer';
import {
  required,
  requiredIf,
  minLength,
  helpers,
} from 'vuelidate/lib/validators';
import Swiper, {
  Autoplay,
  Navigation,
  Pagination,
  EffectFade,
} from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

export default {
  data() {
    return {
      step: 1,
      area: 1,
      banner: {
        text: `We are a company that was born 10 years ago in the living room of one of our
        partners, we never raised money because we always created sustainable projects and
        its the same philosophy
        we had for the stakeholders that work with us, we work
        hard to make their
        sponsorship worth and ve valuable thought time`,
      },
      name: '',
      email: '',
      attachment: '',

      popupImgContent: 'servicios/own/gallery/1.jpg',
      submitStatus: '',
    };
  },
  components: {
    BottomForm: () => import(/* webpackChunkName: "bottomForm" */'../components/BottomForm.vue'),
    MainBanner: () => import(/* webpackChunkName: "mainBanner" */'../components/MainBanner.vue'),
    VZoomer: VueZoomer.Zoomer,
  },
  computed: {
  },
  mounted() {
    this.bannerText = `Lorem ipsum dolor,
    sit amet consectetur adipisicing elit.
    Voluptatibus, harum debitis optio tempora
    error nesciunt totam amet eum laboriosam
    itaque architecto enim soluta laborum minima
    ducimus sequi fugit facere ullam!`;

    this.updateStep(this.$route.query.section);
  },
  validations: {
    name: {
      required,
      minLength: minLength(4),
    },
    email: {
      required,
      alpha: helpers.regex('alpha', /.+@.+\..+/),
    },
    attachment: {
      file: {
        required: requiredIf(function file() {
          return this.attachment.length === 0;
        }),
      },
    },
  },
  watch: {
    step(newValue) {
      if (newValue === 2) {
        this.tabSlider();
      }
    },
    area() {
      this.tabSlider();
    },
    $route(to) {
      const newSection = to.query.section;
      this.updateStep(newSection);
    },
  },
  methods: {
    asd() {
      return this.attachment.length !== 0;
    },
    attachmentFileChanged(event) {
      const files = event.target.files || event.dataTransfer.files;

      if (!files.length) {
        this.attachment = '';

        return;
      }

      [this.attachment] = files;
    },

    submit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR';
      } else {
        this.submitStatus = 'PENDING';
        /* OK code here!!! */
      }
    },
    tabSlider() {
      setTimeout(() => {
        this.bannerSlider = new Swiper('.swiper-container', {
          slidesPerView: 3,
          spaceBetween: 10,
          slidesPerGroup: 1,
          // loop: true,
          // loopFillGroupWithBlank: true,
          // centeredSlides: true,
          // slideToClickedSlide: true,
          loop: true,
          // loopFillGroupWithBlank: false,
          centeredSlidesBounds: true,
          centeredSlides: true,
          autoplay: {
            delay: 6000,
            disableOnInteraction: false,
            // reverseDirection: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }, 500);
    },
    openImgModal(item) {
      this.popupImgContent = item;
      this.$bvModal.show('modalImg');
    },

    updateStep(section) {
      if (section === 'own-products') {
        this.step = 1;
      } else if (section === 'broadcast-es-rights') {
        this.step = 2;
      } else if (section === 'esports-production') {
        this.step = 3;
      }
    },
  },
};
</script>
